import { useState as s } from "react";
function i({
  value: r,
  defaultValue: o,
  finalValue: l,
  onChange: t = () => {
  }
}) {
  const [c, d] = s(
    o !== void 0 ? o : l
  ), n = (e) => {
    d(e), t == null || t(e);
  };
  return r !== void 0 ? [r, t, !0] : [c, n, !1];
}
export {
  i as useUncontrolled
};
